import { FILTER_MOBILE_WRAPPER_SELECTOR, SWATCH_PREFIX } from '../constants/filter-tree';
import { getTemplate } from '../template';
import { formatMoney } from '../utils';
import { getFilterSettings, getSelectedFilter } from '.';
import { applyTranslationsToRefineBy } from './translation';

/**
 * Renders the "Refine By" section by generating HTML from the filter tree context state.
 * check filterLayout render
 * @type {import('./index.d').renderRefineBy}
 */
export function renderRefineBy(context) {
  const { filterLayout, showRefineBy } = getFilterSettings(context);
  const swatchSettings = context.app?.filterSettings?.swatch_settings;

  if (!showRefineBy) return;

  const selectedFilters = getSelectedFilter(context);

  if (selectedFilters && selectedFilters?.length > 0) {
    const data = {
      refineBy: {
        title: 'REFINE BY',
        options: selectedFilters,
      },
    };

    applyTranslationsToRefineBy(context, selectedFilters);

    if (swatchSettings && Object.keys(swatchSettings).length > 0) {
      updateValueDisplayFromSwatch(data, swatchSettings);
    }

    if (filterLayout === 'horizontal') {
      renderRefineByHorizontal(context, data);
    } else {
      renderRefineByVertical(context, data);
    }

    renderRefineByMobile(context, data);
  }
}

/**
 * Renders the "Refine By" section by generating HTML from the filter tree context state.
 * Checks for selected filters and renders their names.
 * If no filters are selected, clears the HTML.
 * @type {import('./index.d').renderRefineByMobile}
 */
export async function renderRefineByMobile(context, data) {
  const doc = context.$('#bc-refine-by-mobile');
  let domRefineBy = '';

  const refineBys = document.querySelectorAll('.boost-sd__custom-refine-by-mobile');

  if (data && (refineBys.length || doc)) {
    domRefineBy = await context.templateRender(getTemplate(context).refineByTemplate, data);
  }

  refineBys?.forEach((renderRefineBy) => {
    renderRefineBy.innerHTML = domRefineBy;
  });

  // mobile style1
  if (doc) {
    doc.innerHTML = domRefineBy;
  } else {
    // mobile other style find boost-sd__filter-option-mobile-items-selected bind
    const selectedByKey = {};
    data?.refineBy?.options?.forEach((select) => {
      if (!select.metaData) return;

      const _key = select.metaData.key;
      if (_key && select.metaData.value) {
        let _value = select.data?.valueDisplay || select.data?.value || select.metaData?.value;
        const isLowerValid = _value?.lower != null;
        const isUpperValid = _value?.upper != null;
        if (select?.type === 'range' && isLowerValid && isUpperValid) {
          const { lower, upper } = _value;
          const numberLower = Number(lower);
          const numberUpper = Number(upper);
          if (!isNaN(numberLower) && !isNaN(numberUpper)) {
            const format = select.data?.moneyFormatValue || '{{amount}}';
            _value = `${formatMoney(context, numberLower, format, false)} - ${formatMoney(
              context,
              numberUpper,
              format,
              false
            )}`;
          }
        }

        if (!selectedByKey[_key]) {
          selectedByKey[_key] = [_value];
        } else {
          selectedByKey[_key] = [...selectedByKey[_key], _value];
        }
      }
    });

    Object.keys(selectedByKey)?.forEach((optionId) => {
      const mobileItemsSelected = context.$(
        `${FILTER_MOBILE_WRAPPER_SELECTOR} #${optionId?.replace(
          /::/g,
          '__'
        )}-toggle-target-label .boost-sd__filter-option-mobile-items-selected`
      );
      if (mobileItemsSelected) {
        mobileItemsSelected.innerHTML = selectedByKey[optionId]?.toString(); // reset selected
      }
    });
  }
}

/**
 * Renders the "Refine By" section by generating HTML from the filter tree context state.
 * Checks for selected filters and renders their names.
 * If no filters are selected, clears the HTML.
 * @type {import('./index.d').renderRefineByVertical}
 */
export async function renderRefineByVertical(context, data) {
  const doc = context.$('#bc-refine-by');

  if (!doc) return;

  if (data) {
    doc.innerHTML = await context.templateRender(getTemplate(context).refineByTemplate, data);
  } else {
    doc.innerHTML = '';
  }
}

/**
 * @type {import('./index.d').renderRefineByHorizontal}
 */
export async function renderRefineByHorizontal(context, data) {
  const doc = context.$('#boost-sd__refine-by-horizontal-place');

  if (!doc) return;

  if (data) {
    doc.innerHTML = await context.templateRender(
      getTemplate(context).refineByHorizontalTemplate,
      data
    );
  } else {
    doc.innerHTML = '';
  }
}

/**
 * @type {import('./index.d').updateValueDisplayFromSwatch}
 */
export function updateValueDisplayFromSwatch(data, swatchSettings) {
  if (!data?.refineBy?.options || !Array.isArray(data.refineBy.options)) return;

  data.refineBy.options.forEach((option) => {
    if (option.type !== 'swatch') return;

    const rawValue = option.data?.value?.trim?.().toLowerCase?.();
    if (!rawValue) return;

    const swatchObj = swatchSettings[rawValue] || swatchSettings[`${SWATCH_PREFIX}${rawValue}`];
    if (swatchObj?.text) {
      option.data.valueDisplay = swatchObj.text;
    }
  });
}
